import { CategoryFilterComponent } from "@/components/CategoryFilters/CategoryFilters.builder";
import { CategoryItemsComponent } from "@/components/CategoryItems/CategoryItems.builder";
import { CategoryNameComponent } from "@/components/CategoryName/CategoryName.builder";

export const categoryCustomComponents: RegisteredComponent[] = [
  CategoryNameComponent,
  CategoryItemsComponent,
  CategoryFilterComponent,
];
